import React from 'react'

import StartTrialBtn from './StartTrialBtn';
import Fast_Company_Logo from '../../assets/images/companies/Fast_Company_logo.svg';
import Tech_Innovators_Logo from '../../assets/images/mains/Technlogy-Innovators-logo.webp';
import Vdosh_Logo from '../../assets/images/companies/vdosh-logo.png';

const NewsLatest = () => {
  return (
      <div className='newsLatest-container mt-3 ' id='press'>
        <div className='container-md'>
            {/* <h2 className='newsLatest-title text-center' x-intersect="$el.classList.add('fadeInUp-parallax')">News and Latest updates</h2> */}
            <h2 className='newsLatest-title text-center' >News and Latest updates</h2>
            <div className='flex news-conatiner mt-5'>
                  <NewsItem
                      icon={Vdosh_Logo}
                      desc="VDOSH Makes Investment in CausalFunnel"
                      url="https://www.prlog.org/12893456-vdosh-makes-investment-in-data-science-platform-causalfunnel.html"
                  />
                  <NewsItem
                      icon={Tech_Innovators_Logo}
                      desc="CausalFunnel named Top 50 AI CEOs of 2021 by Technology Innovators Magazine."
                      url="https://www.technology-innovators.com/causalfunnel/"
                  />
                  <NewsItem
                      icon={Fast_Company_Logo}
                      desc="CausalFunnel invited to the Fast Company Executive Board for our industry expertise."
                      url="https://board.fastcompany.com/profile/Abhimanu-Kumar-Co-Founder-CausalFunnel/2e3b0235-6189-4763-832f-a97a6d49f4b2"
                  />
            </div>
            <div className="my-5 text-center" x-intersect="$el.classList.add('fadeInUp-parallax')">
                <StartTrialBtn title="Start Free Trial" href="/free-trial"/>
            </div>
        </div>
    </div>
  )
}

export default NewsLatest


export const NewsItem = ({ icon, desc, url }) => {
    return (
        // <div className='newsItem m-md-1 m-lg-1' onClick={()=> window.open(url, "_blank")} x-intersect="$el.classList.add('feature-parallax')">
        <div className='newsItem m-md-1 m-lg-1' onClick={()=> window.open(url, "_blank")} >
            <p>{desc}</p>
            <div className='text-center'>
                <img className='companyLogo' src={icon}/>
            </div>
        </div>
    )
}